import React from 'react';

import { Box, Typography } from '@mui/material';

import { ScreenshotFallback } from './components/ScreenshotFallback';
import { ScreenshotImage } from './components/ScreenshotImage';
import { ScreenshotSkeleton } from './components/ScreenshotSkeleton';

import type { ScreenshotPreviewViewProperties } from './ScreenshotPreviewView.types';

export const ScreenshotPreviewView: React.FC<ScreenshotPreviewViewProperties> = ({
  isPending,
  showFallback,
  fallbackColor,
  screenshotUrl,
  url,
  urlNormalised = '',
  onImageError,
  dataTest = 'screenshot_preview',
}) => (
  <Box data-testid={dataTest} sx={{ position: 'relative' }}>
    {isPending ? (
      <ScreenshotSkeleton dataTest={`${dataTest}_skeleton`} />
    ) : showFallback ? (
      <ScreenshotFallback
        fallbackColor={fallbackColor}
        urlNormalised={urlNormalised}
        url={url}
        dataTest={`${dataTest}_fallback`}
      />
    ) : (
      <ScreenshotImage
        screenshotUrl={screenshotUrl}
        onImageError={onImageError}
        dataTest={`${dataTest}_image`}
      />
    )}
    <Typography
      data-testid={`${dataTest}_domain_badge`}
      sx={{
        position: 'absolute',
        right: 8,
        bottom: 8,
        backgroundColor: 'rgba(0,0,0,0.6)',
        color: 'white',
        fontSize: '11px',
        fontWeight: 500,
        px: 1,
        py: '2px',
        borderRadius: '4px',
      }}
    >
      {urlNormalised}
    </Typography>
  </Box>
);
